import React, { useContext, useState } from 'react'
import { motion } from 'framer-motion'
import styles from './LbGsAddDomain.module.css'
import { Link, useNavigate } from 'react-router';
import { BASE_URL_API } from '../../References/URLs';
import AuthContext from '../../store/auth-context';
import ActiveStoreContext from '../../store/ActiveStoreContext';
import { toast } from 'react-toastify';
import { FaSpinner } from 'react-icons/fa6';
import { isValidDomain } from '../../Helper/utility';

const LbGsAddDomain = ({ onNext, onPrev }) => {
    const authCtx = useContext(AuthContext);
    const asCtx = useContext(ActiveStoreContext);
    const activeStore = (() => { try { return asCtx?.activeStore && asCtx.activeStore.trim() !== "" ? JSON.parse(asCtx.activeStore) : null; } catch { return null; } })();
    const vendorIdentifier = JSON.parse(authCtx?.loginData)?.partnersData?.vendorIdentifier
    const [isCreating, setIsCreating] = useState(false)
    const [domain, setDomain] = useState('');
    const nav = useNavigate()

    const handleNext = () => {
        if (domain.trim() !== '') {
            lb_createDomain()
            // onNext(domain); // pass domain up if needed
        } else {
            alert('Please enter a domain to proceed.');
        }
    };

    const lb_createDomain = async () => {
        if(!isValidDomain(domain)) {
            alert("Please enter a valid domain!")
            return;
        }

        const payload = JSON.stringify({
            token: authCtx.token,
            vendorIdentifier: vendorIdentifier,
            domain: domain,
            storeIdentifier: activeStore.storeIdentifier,
            authIdentifier: authCtx.authIdentifier
        });
        setIsCreating(true)
        const createDomainResponse = await fetch(BASE_URL_API + "lb_createDomain",
            {
                method: "POST",
                body: payload
            });

        if (!createDomainResponse.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const createDomainRespo = await createDomainResponse.json()
            if (createDomainRespo.status === "success") {
                toast(`Domain created successfully!`)
                nav(`/leadbridge/get-started/create-form`)
            } else {
                if (createDomainRespo.message === "tokenExpired") {
                    authCtx.logout()
                } else {
                    toast.error(`Domain creation failed : Domain ${createDomainRespo?.message}`)
                }
                console.log(createDomainRespo)
            }
        }
        setIsCreating(false)
    }


    if (activeStore === null) {
        return (
            <div className={styles.mainWrapper}>
                <div className={styles.mainContainer}>
                    <div className={styles.mainContent}>
                        Please select a store!
                    </div>
                </div>
            </div>
        )
    }

    return (
        <motion.div
            className={styles.addDomainContainer}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -30 }}
            transition={{ duration: 0.6 }}
        >
            <div className={styles.contentWrapper}>
                <h2>Connect Your Website</h2>
                <p>Enter the domain name of your website. This is where your forms will be embedded and tracked.</p>

                <input
                    type="text"
                    placeholder="e.g. www.beautysalon.com"
                    value={domain}
                    onChange={(e) => setDomain(e.target.value)}
                    className={styles.inputField}
                    autoFocus={true}
                />
            </div>

            <div className={styles.stickyNav}>
                <Link to={`/leadbridge/get-started`} className={styles.secondaryBtn} onClick={onPrev}>← Back</Link>
                {isCreating === false ?
                    <button className={styles.primaryBtn} onClick={handleNext}>Continue →</button>
                    :
                    <button className={styles.primaryBtn}>
                        <FaSpinner className={styles.spinner} /> Creating...
                    </button>
                }
            </div>
        </motion.div>
    )
}

export default LbGsAddDomain
